const muster = require('@dbk-legacy/muster');
const falcor = require('falcor/dist/falcor.browser');
const { createDefaultHandlers } = require('./default-handlers');


/**
 * Create a muster module with routes connected to a falcor model
 *
 * @param {Array<function>} routers Collection of functions that enhance a muster app instance with
 * additonal routes
 * @param {object|string} model Url to an external falcor model, or an in-memory jsonGraph object
 * @param {object} musterOptions Optional options to pass through to the internal muster instance
 *
 * @returns {Muster.Router} Muster app instance
 */
function createClient(routers, model, musterOptions) {
  const falcorConfig = getFalcorConfig(model);
  const falcorModel = new falcor.Model(falcorConfig);

  const musterApp = muster(musterOptions);
  const defaultHandlers = createDefaultHandlers(falcorModel);

  routers.forEach((router) => router(musterApp, falcorModel, defaultHandlers));

  return musterApp;
}

module.exports = createClient;

function getFalcorConfig(model) {


  const config = {
    headers:{
      "Strict-Transport-Security": "max-age=15768000"
    },
    timeout: 9000000
  };

  if (typeof model === 'string') {
    return {
      source: new falcor.HttpDataSource(model, config),
    };
  }
  return {
    cache: model,
  };
}
